import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import * as actions from '../../redux/actions'
import { centsToText } from '../../services/MoneyHelper'

import Interface from '../../components/Interface'

import detectBrowserLanguage from 'detect-browser-language'
import WhatsAppShopDoubt from '../../components/WhatsAppShopDoubt'
import Loader from 'react-loader-spinner'
import { AiFillEdit } from 'react-icons/ai'
import { FiFileText } from 'react-icons/fi'
import moment from 'moment'
import rp from 'request-promise-native'
import { uriV2 } from '../../services/defaultProps'

const styles = {
  picker: {
    width: '100%',
    boxSizing: 'border-box',
    padding: '3px',
    fontWeight: 'bold',
    color: '#6d357b',
    marginTop: '16px'
  }
}

const renderLoading = () => (
  <div style={{ position: 'absolute', top: 100, left: '50%', transform: 'translate(-50%, 0)' }}>
    <Loader
      type='TailSpin'
      color='#6d357b'
      height='50'
      width='50'
    />
  </div>
)

class ServiceBillingCheckout extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoading: true,
      language: 1,
      installments: 0
    }

    if (this.props.location.state) {
      this.maxInstallments = this.props.location.state.serviceBilling.maxInstallments
    }
  }

  componentWillMount () {
    if (!this.props.payerInfo || !this.props.card || this.props.card.length === 0 || !this.props.location.state) {
      return this.props.history.push('/')
    }

    if (!localStorage.getItem('language')) {
      if (detectBrowserLanguage() === 'pt-BR' || detectBrowserLanguage() === 'pt-PT' || detectBrowserLanguage() === 'pt' || detectBrowserLanguage().slice(0, 2) === 'pt') {
        this.setState({ language: 0 })
        localStorage.setItem('language', '0')
      }
      if (detectBrowserLanguage().slice(0, 2) === 'es') {
        this.setState({ language: 2 })
        localStorage.setItem('language', '2')
      }
    } else {
      this.setState({ language: localStorage.getItem('language') - '0' })
    }
    this.setState({isLoading: false})
  }

  handleContinueButton = async () => {
    const currentBilling = this.props.allBillings.find(
      billing => billing.id === this.props.location.state.serviceBilling.id
    )

    if (currentBilling && (currentBilling.status === 'paid' || currentBilling.status === 'created')) {
      window.alert('Essa cobrança já foi paga.')
      return this.props.history.push('/cobrancas', {
        fromCheckout: true
      })
    }

    const selectedCard = this.getDefaultCard()

    const body = {
      serviceBillingId: this.props.location.state.serviceBilling.id,
      payerId: this.props.payerInfo.id,
      installments: Number(this.state.installments),
      paymentMethodIdentifier: selectedCard.id
    }

    if (body.installments === 0) {
      return window.alert('Selecione o número de parcelas!')
    }

    this.setState({isLoading: true})

    rp({
      uri: `${uriV2}/financial/billing/order`,
      method: 'POST',
      headers: {
        Authorization: this.props.token
      },
      body,
      json: true
    })
      .then(res => {
        this.props.setPendingBillings(res)
        this.props.setAllBillings(res)
        this.props.history.push('/cobrancas', {
          fromCheckout: true
        })
      })
      .catch(err => console.error(err))
      .finally(() => this.setState({isLoading: false}))
  }

  getDefaultCard = () => {
    return this.props.card.find(card => card.status === 'active' && card.isDefault)
  }

  renderInstallments = () => {
    const newArray = new Array(this.maxInstallments).fill(0)
    const formattedArray = newArray.map((item, index) => {
      return index + 1
    })

    return formattedArray.map(item => {
      return (
        <option key={item} value={item}>{item}</option>
      )
    })
  }

  renderFinalPrice = () => {
    return centsToText(Math.trunc((this.props.location.state.serviceBilling.price / this.state.installments)))
  }

  getDefaultCard = () => {
    return this.props.card.find(card => card.status === 'active' && card.isDefault)
  }

  renderServiceBillingSummary = () => {
    const selectedCard = this.getDefaultCard()
    return (
      <div>
        <div style={{display: 'flex', alignItems: 'center', whiteSpace: 'pre-wrap', padding: 16}}>
          <h2 className='shop-description-header' style={{margin: 0}}>Informações da cobrança {'   '}</h2>
        </div>
        <div style={{padding: '0px 16px'}}>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            Serviço: {this.props.location.state.serviceBilling.clientService.consultantService.name}
          </p>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            Vencimento: {moment(this.props.location.state.serviceBilling.dueDate, 'YYYY-MM-DD').format('DD/MM/YYYY')}
          </p>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            Valor a pagar: {centsToText(this.props.location.state.serviceBilling.price)}
          </p>
        </div>
        <div style={{display: 'flex', alignItems: 'center', whiteSpace: 'pre-wrap', padding: 16}}>
          <h2 className='shop-description-header' style={{margin: 0}}>Pagamento {'   '}</h2>
          <p style={{fontSize: '16px', margin: 0, color: '#94428a'}}>
            (<AiFillEdit size='14' color='#94428a' />
            <u onClick={() => this.props.history.push('/dados-cobranca/cartao/adicionar', {
              update: true,
              serviceBilling: this.props.location.state.serviceBilling
            })}>
              trocar
            </u>)
          </p>
        </div>
        <div style={{padding: '0px 16px'}}>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            {selectedCard && selectedCard.fullname}
          </p>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            {`**** ${selectedCard && selectedCard.last4}`}
          </p>
          <p style={{margin: '4px 0px', fontSize: '20px'}}>
            {selectedCard && selectedCard.brand}
          </p>
          <h3 className='shop-description-header' style={{margin: 0, marginTop: 16}}>Parcelas {'   '}</h3>
          <select defaultValue={0} style={styles.picker}
            onChange={e => this.setState({ installments: e.target.value })}>
            <option value={this.state.installments} disabled>
                  Selecione o número de parcelas
            </option>
            {this.renderInstallments()}
          </select>
          {this.state.installments !== 0 && (
            <Fragment>
              <div style={{backgroundColor: 'rgba(148, 66, 138, 0.5)', height: '1px', width: '100%', margin: 'auto', marginTop: 16}} />
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <h2 className='shop-description-header' style={{margin: 0, marginTop: 16}}>
                  Total
                </h2>
                <h2 className='shop-description-header' style={{margin: 0, marginTop: 16}}>
                  {this.state.installments}x de {this.renderFinalPrice()}
                </h2>
              </div>
            </Fragment>
          )}
        </div>
      </div>
    )
  }

  renderContent = () => {
    return (
      <div style={{display: 'flex', flexDirection: 'column', height: 'calc(100vh - 50px)'}}>
        <div style={{ padding: '8px', display: 'flex', flexDirection: 'column', overflowY: 'scroll' }}>
          <div style={{width: '100%', maxWidth: '720px', marginRight: 'auto', marginLeft: 'auto'}}>
            {this.renderServiceBillingSummary()}
            <div style={{backgroundColor: 'rgba(148, 66, 138, 0.5)', height: '1px', width: '90%', margin: 'auto', marginTop: 16}} />
            <WhatsAppShopDoubt clientName={this.props.user.name} />
          </div>
        </div>
        <div onClick={this.handleContinueButton} style={{marginTop: 'auto', width: '100%'}}>
          <div id='purchase' >
            Finalizar compra
          </div>
        </div>
      </div>
    )
  }

  render () {
    return (
      <Interface
        title='Resumo da cobrança'
        history={this.props.history}
        showFooter={false}
        backgroundClass='shop-background'
        logoIcon={
          <FiFileText size='24'
            color='#94428a'
          />
        }
        customPadding={4}
      >
        {this.state.isLoading ? renderLoading() : this.renderContent()}
      </Interface>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer,
    payerInfo: state.productsReducer.payerInfo,
    deliveryAddress: state.productsReducer.deliveryAddress,
    card: state.productsReducer.card,
    allBillings: state.billingAndBlockStatusReducer.allBillings
  }
}

export default connect(mapStateToProps, actions)(ServiceBillingCheckout)



// WEBPACK FOOTER //
// ./src/containers/Shop/ServiceBillingCheckout.js